module.exports = __webpack_public_path__ + "img/Artfolio.c9a66b21.png";